import { render, staticRenderFns } from "./modificaFirma.vue?vue&type=template&id=79a22e64"
import script from "./modificaFirma.vue?vue&type=script&lang=js"
export * from "./modificaFirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports